export const CitiesListMap = {
  default: [
    {
      title: 'popular cities',
      citieslist: [
        {
          name: 'Delhi',
          code: 'MMTCC1199',
          fullName: 'Delhi'
        },
        {
          name: 'Bangalore',
          code: 'MMTCC1092',
          fullName: 'Bangalore, Karnataka'
        },
        {
          name: 'Mumbai',
          code: 'MMTCC1599',
          fullName: 'Mumbai, Maharashtra'
        },
        {
          name: 'Pune',
          code: 'MMTCC1744',
          fullName: 'Pune, Maharashtra'
        },
        {
          name: 'Chennai',
          code: 'MMTCC1159',
          fullName: 'Chennai, Tamil Nadu'
        },
        {
          name: 'Hyderabad',
          code: 'MMTCC1319',
          fullName: 'Hyderabad, Telangana'
        },
        {
          name: 'Chandigarh',
          code: 'MMTCC1149',
          fullName: 'Chandigarh'
        },
        {
          name: 'Kolkata',
          code: 'MMTCC6117',
          fullName: 'Kolkata, West Bengal'
        },
        {
          name: 'Jaipur',
          code: 'MMTCC1333',
          fullName: 'Jaipur, Rajasthan'
        },
        {
          name: 'Lucknow',
          code: 'MMTCC2161',
          fullName: 'Lucknow, Uttar Pradesh'
        },
        {
          name: 'Coimbatore',
          code: 'MMTCC1184',
          fullName: 'Coimbatore, Tamil Nadu'
        },
        {
          name: 'Goa',
          code: 'MMTCC1271',
          fullName: 'Goa'
        },
        {
          name: 'Manali',
          code: 'MMTCC1543',
          fullName: 'Manali, Himachal Pradesh'
        },
        {
          name: 'Shimla',
          code: 'MMTCC1815',
          fullName: 'Shimla, Himachal Pradesh'
        },
        {
          name: 'Haridwar',
          code: 'MMTCC1295',
          fullName: 'Haridwar, Uttarakhand'
        },
        {
          name: 'Dehradun',
          code: 'MMTCC1198',
          fullName: 'Dehradun, Uttarakhand'
        },
        {
          name: 'Katra',
          code: 'MMTCC43152',
          fullName: 'Katra, Jammu and Kashmir'
        },
        {
          name: 'Rishikesh',
          code: 'MMTCC1781',
          fullName: 'Rishikesh, Uttarakhand'
        },
        {
          name: 'Nainital',
          code: 'MMTCC1621',
          fullName: 'Nainital, Uttarakhand'
        },
        {
          name: 'Dharamshala',
          code: 'MMTCC6060',
          fullName: 'Dharamshala, Himachal Pradesh'
        },
        {
          name: 'Amritsar',
          code: 'MMTCC1043',
          fullName: 'Amritsar, Punjab'
        },
        {
          name: 'Agra',
          code: 'MMTCC3641',
          fullName: 'Agra, Uttar Pradesh'
        },
        {
          name: 'Jammu',
          code: 'MMTCC47573',
          fullName: 'Jammu, Jammu and Kashmir'
        },
        {
          name: 'Mussoorie',
          code: 'MMTCC3701',
          fullName: 'Mussoorie, Uttarakhand'
        },
        {
          name: 'Kanpur',
          code: 'MMTCC2140',
          fullName: 'Kanpur, Uttar Pradesh'
        },
        {
          name: 'Mcleod Ganj',
          code: 'MMTCC10671',
          fullName: 'Mcleod Ganj, Himachal Pradesh'
        },
        {
          name: 'Haldwani',
          code: 'MMTCC3674',
          fullName: 'Haldwani, Uttarakhand'
        },
        {
          name: 'Varanasi',
          code: 'MMTCC5425',
          fullName: ' Varanasi, Uttar Pradesh'
        },
        {
          name: 'Gorakhpur',
          code: 'MMTCC5780',
          fullName: 'Gorakhpur, Uttar Pradesh'
        },
        {
          name: 'Tirupati',
          code: 'MMTCC1924',
          fullName: 'Tirupati, Andhra Pradesh'
        },
        {
          name: 'Ooty',
          code: 'MMTCC1661',
          fullName: 'Ooty, Tamil Nadu'
        },
        {
          name: 'Coorg',
          code: 'MMTCC6739',
          fullName: 'Coorg, Karnataka'
        },
        {
          name: 'Mysore',
          code: 'MMTCC1611',
          fullName: 'Mysore, Karnataka'
        },
        {
          name: 'Mangalore',
          code: 'MMTCC1553',
          fullName: 'Mangalore, Karnataka'
        },
        {
          name: 'Pondicherry',
          code: 'MMTCC1732',
          fullName: 'Pondicherry'
        },
        {
          name: 'Shirdi',
          code: 'MMTCC1819',
          fullName: 'Shirdi, Maharashtra'
        },
        {
          name: 'Munnar',
          code: 'MMTCC1604',
          fullName: 'Munnar, Kerala'
        },
        {
          name: 'Vijayawada',
          code: 'MMTCC1995',
          fullName: 'Vijayawada, Andhra Pradesh'
        },
        {
          name: 'Kodaikanal',
          code: 'MMTCC1449',
          fullName: 'Kodaikanal, Tamil Nadu'
        },
        {
          name: 'Madurai',
          code: 'MMTCC1526',
          fullName: 'Madurai, Tamil Nadu'
        },
        {
          name: 'Trivandrum',
          code: 'MMTCC43372',
          fullName: 'Trivandrum, Kerala'
        },
        {
          name: 'Ernakulam',
          code: 'MMTCC1248',
          fullName: 'Ernakulam, Kerala'
        },
        {
          name: 'Mysore (Sightseeing)',
          code: 'MMTCC43321',
          fullName: 'Mysore, Karnataka'
        },
        {
          name: 'Mumbai Darshan',
          code: 'MMTCC2513',
          fullName: 'Mumbai Darshan, Maharashtra'
        },
        {
          name: 'Kolhapur',
          code: 'MMTCC43090',
          fullName: 'Kolhapur, Maharashtra'
        },
        {
          name: 'Mahabaleshwar',
          code: 'MMTCC1528',
          fullName: 'Mahabaleshwar, Maharashtra'
        },
        {
          name: 'Indore',
          code: 'MMTCC1324',
          fullName: 'Indore, Madhya Pradesh'
        },
        {
          name: 'Ahmedabad',
          code: 'MMTCC1015',
          fullName: 'Ahmedabad, Gujarat'
        },
        {
          name: 'Aurangabad',
          code: 'MMTCC1070',
          fullName: 'Aurangabad, Maharashtra'
        },
        {
          name: 'Ratnagiri',
          code: 'MMTCC3859',
          fullName: 'Ratnagiri, Maharashtra'
        },
        {
          name: 'Nasik',
          code: 'MMTCC1640',
          fullName: 'Nasik, Maharashtra'
        },
        {
          name: 'Nagpur',
          code: 'MMTCC1619',
          fullName: 'Nagpur, Maharashtra'
        },
        {
          name: 'Belgaum',
          code: 'MMTCC1103',
          fullName: 'Belgaum, Karnataka'
        },
        {
          name: 'Surat',
          code: 'MMTCC1865',
          fullName: 'Surat, Gujarat'
        },
        {
          name: 'Lonavala',
          code: 'MMTCC1516',
          fullName: 'Lonavala, Maharashtra'
        },
        {
          name: 'Bhopal',
          code: 'MMTCC1119',
          fullName: 'Bhopal, Madhya Pradesh'
        },
        {
          name: 'Latur',
          code: 'MMTCC1508',
          fullName: 'Latur, Maharashtra'
        },
        {
          name: 'Nanded',
          code: 'MMTCC1628',
          fullName: 'Nanded, Maharashtra'
        },
        {
          name: 'Jalgaon',
          code: 'MMTCC1337',
          fullName: 'Jalgaon, Maharashtra'
        },
        {
          name: 'Amravati (MH)',
          code: 'MMTCC43169',
          fullName: 'Amravati, Maharashtra'
        },
        {
          name: 'Vadodara (Baroda)',
          code: 'MMTCC43363',
          fullName: 'Vadodara, Gujarat'
        },
        {
          name: 'Trichy',
          code: 'MMTCC1931',
          fullName: 'Trichy, Tamil Nadu'
        },
        {
          name: 'Salem',
          code: 'MMTCC1791',
          fullName: 'Salem, Tamil Nadu'
        },
        {
          name: 'Nagercoil',
          code: 'MMTCC1616',
          fullName: 'Nagercoil, Tamil Nadu'
        },
        {
          name: 'Kumbakonam',
          code: 'MMTCC1488',
          fullName: 'Kumbakonam, Tamil Nadu'
        },
        {
          name: 'Velankanni',
          code: 'MMTCC1985',
          fullName: 'Velankanni, Tamil Nadu'
        },
        {
          name: 'Erode',
          code: 'MMTCC1249',
          fullName: 'Erode, Tamil Nadu'
        },
        {
          name: 'Vellore',
          code: 'MMTCC1986',
          fullName: 'Vellore, Tamil Nadu'
        },
        {
          name: 'Dindigul',
          code: 'MMTCC1223',
          fullName: 'Dindigul, Tamil Nadu'
        },
        {
          name: 'Visakhapatnam (Vizag)',
          code: 'MMTCC43255',
          fullName: 'Visakhapatnam, Andhra Pradesh'
        },
        {
          name: 'Rajahmundry',
          code: 'MMTCC5916',
          fullName: 'Rajahmundry, Andhra Pradesh'
        },
        {
          name: 'Guntur',
          code: 'MMTCC1288',
          fullName: 'Guntur, Andhra Pradesh'
        },
        {
          name: 'Nellore',
          code: 'MMTCC1644',
          fullName: 'Nellore, Andhra Pradesh'
        },
        {
          name: 'Kakinada',
          code: 'MMTCC1363',
          fullName: 'Kakinada, Andhra Pradesh'
        },
        {
          name: 'Ramoji Film City',
          code: 'MMTCC9999',
          fullName: 'Ramoji Film City, Andhra Pradesh'
        },
        {
          name: 'Kullu',
          code: 'MMTCC1487',
          fullName: 'Kullu, Himachal Pradesh'
        },
        {
          name: 'Pathankot',
          code: 'MMTCC3712',
          fullName: 'Pathankot, Punjab'
        },
        {
          name: 'Jalandhar',
          code: 'MMTCC1336',
          fullName: 'Jalandhar, Punjab'
        },
        {
          name: 'Ludhiana',
          code: 'MMTCC1517',
          fullName: 'Ludhiana, Punjab'
        },
        {
          name: 'Bathinda',
          code: 'MMTCC6089',
          fullName: 'Bathinda, Punjab'
        },
        {
          name: 'Mandi',
          code: 'MMTCC14043',
          fullName: 'Mandi, Punjab'
        },
        {
          name: 'Bhuntar',
          code: 'MMTCC10565',
          fullName: 'Bhuntar, Himachal Pradesh'
        },
        {
          name: 'Hamirpur',
          code: 'MMTCC6061',
          fullName: 'Hamirpur,Himachal Pradesh'
        },
        {
          name: 'Kangra',
          code: 'MMTCC3682',
          fullName: 'Kangra, Himachal Pradesh'
        },
        {
          name: 'Hoshiarpur',
          code: 'MMTCC6094',
          fullName: 'Hoshiarpur, Punjab'
        },
        {
          name: 'Siliguri',
          code: 'MMTCC5560',
          fullName: 'Siliguri, West Bengal'
        },
        {
          name: 'Digha',
          code: 'MMTCC5569',
          fullName: 'Digha, West Bengal'
        },
        {
          name: 'Puri',
          code: 'MMTCC5586',
          fullName: 'Puri, Odisha'
        },
        {
          name: 'Bhubaneswar',
          code: 'MMTCC5474',
          fullName: 'Bhubaneswar, Odisha'
        },
        {
          name: 'Durgapur',
          code: 'MMTCC5568',
          fullName: 'Durgapur, West Bengal'
        },
        {
          name: 'Patna',
          code: 'MMTCC6045',
          fullName: 'Patna, Bihar'
        },
        {
          name: 'Asansol',
          code: 'MMTCC5575',
          fullName: 'Asansol, West Bengal'
        },
        {
          name: 'Malda',
          code: 'MMTCC5578',
          fullName: 'Malda, West Bengal'
        },
        {
          name: 'Ranchi',
          code: 'MMTCC6064',
          fullName: 'Ranchi, Jharkhand'
        },
        {
          name: 'Mandarmani',
          code: 'MMTCC37974',
          fullName: 'Mandarmani, West Bengal'
        },
        {
          name: 'Cuttack',
          code: 'MMTCC5502',
          fullName: 'Cuttack, Odisha'
        },
        {
          name: 'Bokaro',
          code: 'MMTCC5579',
          fullName: 'Bokaro, Jharkhand'
        },
        {
          name: 'Dhanbad',
          code: 'MMTCC5580',
          fullName: 'Dhanbad, Jharkhand'
        },
        {
          name: 'Haldia',
          code: 'MMTCC5577',
          fullName: 'Haldia, West Bengal'
        },
        {
          name: 'Udaipur (Rajasthan)',
          code: 'MMTCC38804',
          fullName: 'Udaipur, Rajasthan'
        },
        {
          name: 'Jodhpur',
          code: 'MMTCC1349',
          fullName: 'Jodhpur, Rajasthan'
        },
        {
          name: 'Gurgaon',
          code: 'MMTCC5409',
          fullName: 'Gurgaon, Haryana'
        },
        {
          name: 'Bikaner',
          code: 'MMTCC1126',
          fullName: 'Bikaner, Rajasthan'
        },
        {
          name: 'Ajmer',
          code: 'MMTCC1019',
          fullName: 'Ajmer, Rajasthan'
        },
        {
          name: 'Kota Rajasthan',
          code: 'MMTCC43246',
          fullName: 'Kota, Rajasthan'
        },
        {
          name: 'Gwalior',
          code: 'MMTCC5366',
          fullName: 'Gwalior, Madhya Pradesh'
        },
        {
          name: 'Mount Abu',
          code: 'MMTCC12671',
          fullName: 'Mount Abu, Rajasthan'
        },
        {
          name: 'Allahabad',
          code: 'MMTCC5713',
          fullName: 'Allahabad, Uttar Pradesh'
        },
        {
          name: 'Azamgarh',
          code: 'MMTCC6107',
          fullName: 'Azamgarh, Uttar Pradesh'
        },
        {
          name: 'Jhansi',
          code: 'MMTCC2130',
          fullName: 'Jhansi, Uttar Pradesh'
        },
        {
          name: 'Bareilly',
          code: 'MMTCC2081',
          fullName: 'Bareilly, Uttar Pradesh'
        },
        {
          name: 'Ghaziabad',
          code: 'MMTCC43265',
          fullName: 'Ghaziabad, Uttar Pradesh'
        },
        {
          name: 'Noida',
          code: 'MMTCC2195',
          fullName: 'Noida, Uttar Pradesh'
        },
        {
          name: 'Moradabad',
          code: 'MMTCC2182',
          fullName: 'Moradabad, Uttar Pradesh'
        },
        {
          name: 'Mau',
          code: 'MMTCC6869',
          fullName: 'Mau, Uttar Pradesh'
        },
        {
          name: 'Cochin',
          code: 'MMTCC37575',
          fullName: 'Cochin, Kerala'
        },
        {
          name: 'Tiruchendur',
          code: 'MMTCC1917',
          fullName: 'Tiruchendur, Tamil Nadu'
        },
        {
          name: 'Ambala',
          code: 'MMTCC2069',
          fullName: 'Ambala, Haryana'
        }
      ]
    }
  ],
  MMTCC1199: [
    {
      title: 'popular cities',
      citieslist: [
        {
          name: 'Manali',
          code: 'MMTCC1543',
          fullName: 'Manali, Himachal Pradesh'
        },
        {
          name: 'Haridwar',
          code: 'MMTCC1295',
          fullName: 'Haridwar, Uttarakhand'
        },
        {
          name: 'Shimla',
          code: 'MMTCC1815',
          fullName: 'Shimla, Himachal Pradesh'
        },
        {
          name: 'Dehradun',
          code: 'MMTCC1198',
          fullName: 'Dehradun, Uttarakhand'
        },
        {
          name: 'Katra',
          code: 'MMTCC43152',
          fullName: 'Katra, Jammu and Kashmir'
        },
        {
          name: 'Rishikesh',
          code: 'MMTCC1781',
          fullName: 'Rishikesh, Uttarakhand'
        },
        {
          name: 'Jaipur',
          code: 'MMTCC1333',
          fullName: 'Jaipur, Rajasthan'
        },
        {
          name: 'Chandigarh',
          code: 'MMTCC1149',
          fullName: 'Chandigarh'
        },
        {
          name: 'Lucknow',
          code: 'MMTCC2161',
          fullName: 'Lucknow, Uttar Pradesh'
        },
        {
          name: 'Nainital',
          code: 'MMTCC1621',
          fullName: 'Nainital, Uttarakhand'
        },
        {
          name: 'Dharamshala',
          code: 'MMTCC6060',
          fullName: 'Dharamshala, Himachal Pradesh'
        },
        {
          name: 'Amritsar',
          code: 'MMTCC1043',
          fullName: 'Amritsar, Punjab'
        },
        {
          name: 'Agra',
          code: 'MMTCC3641',
          fullName: 'Agra, Uttar Pradesh'
        },
        {
          name: 'Jammu',
          code: 'MMTCC47573',
          fullName: 'Jammu, Jammu and Kashmir'
        },
        {
          name: 'Mussoorie',
          code: 'MMTCC3701',
          fullName: 'Mussoorie, Uttarakhand'
        },
        {
          name: 'Kanpur',
          code: 'MMTCC2140',
          fullName: 'Kanpur, Uttar Pradesh'
        },
        {
          name: 'Mcleod Ganj',
          code: 'MMTCC10671',
          fullName: 'Mcleod Ganj, Himachal Pradesh'
        },
        {
          name: 'Haldwani',
          code: 'MMTCC3674',
          fullName: 'Haldwani, Uttarakhand'
        },
        {
          name: 'Varanasi',
          code: 'MMTCC5425',
          fullName: ' Varanasi, Uttar Pradesh'
        },
        {
          name: 'Gorakhpur',
          code: 'MMTCC5780',
          fullName: 'Gorakhpur, Uttar Pradesh'
        }
      ]
    }
  ],
  MMTCC1092: [
    {
      title: 'popular cities',
      citieslist: [
        {
          name: 'Hyderabad',
          code: 'MMTCC1319',
          fullName: 'Hyderabad, Telangana'
        },
        {
          name: 'Chennai',
          code: 'MMTCC1159',
          fullName: 'Chennai, Tamil Nadu'
        },
        {
          name: 'Goa',
          code: 'MMTCC1271',
          fullName: 'Goa'
        },
        {
          name: 'Mumbai',
          code: 'MMTCC1599',
          fullName: 'Mumbai, Maharashtra'
        },
        {
          name: 'Tirupati',
          code: 'MMTCC1924',
          fullName: 'Tirupati, Andhra Pradesh'
        },
        {
          name: 'Pune',
          code: 'MMTCC1744',
          fullName: 'Pune, Maharashtra'
        },
        {
          name: 'Ooty',
          code: 'MMTCC1661',
          fullName: 'Ooty, Tamil Nadu'
        },
        {
          name: 'Coorg',
          code: 'MMTCC6739',
          fullName: 'Coorg, Karnataka'
        },
        {
          name: 'Mysore',
          code: 'MMTCC1611',
          fullName: 'Mysore, Karnataka'
        },
        {
          name: 'Coimbatore',
          code: 'MMTCC1184',
          fullName: 'Coimbatore, Tamil Nadu'
        },
        {
          name: 'Mangalore',
          code: 'MMTCC1553',
          fullName: 'Mangalore, Karnataka'
        },
        {
          name: 'Pondicherry',
          code: 'MMTCC1732',
          fullName: 'Pondicherry'
        },
        {
          name: 'Shirdi',
          code: 'MMTCC1819',
          fullName: 'Shirdi, Maharashtra'
        },
        {
          name: 'Munnar',
          code: 'MMTCC1604',
          fullName: 'Munnar, Kerala'
        },
        {
          name: 'Vijayawada',
          code: 'MMTCC1995',
          fullName: 'Vijayawada, Andhra Pradesh'
        },
        {
          name: 'Kodaikanal',
          code: 'MMTCC1449',
          fullName: 'Kodaikanal, Tamil Nadu'
        },
        {
          name: 'Madurai',
          code: 'MMTCC1526',
          fullName: 'Madurai, Tamil Nadu'
        },
        {
          name: 'Trivandrum',
          code: 'MMTCC43372',
          fullName: 'Trivandrum, Kerala'
        },
        {
          name: 'Ernakulam',
          code: 'MMTCC1248',
          fullName: 'Ernakulam, Kerala'
        },
        {
          name: 'Mysore (Sightseeing)',
          code: 'MMTCC43321',
          fullName: 'Mysore, Karnataka'
        }
      ]
    }
  ],
  MMTCC1599: [
    {
      title: 'popular cities',
      citieslist: [
        {
          name: 'Goa',
          code: 'MMTCC1271',
          fullName: 'Goa'
        },
        {
          name: 'Bangalore',
          code: 'MMTCC1092',
          fullName: 'Bangalore, Karnataka'
        },
        {
          name: 'Mumbai Darshan',
          code: 'MMTCC2513',
          fullName: 'Mumbai Darshan, Maharashtra'
        },
        {
          name: 'Pune',
          code: 'MMTCC1744',
          fullName: 'Pune, Maharashtra'
        },
        {
          name: 'Shirdi',
          code: 'MMTCC1819',
          fullName: 'Shirdi, Maharashtra'
        },
        {
          name: 'Hyderabad',
          code: 'MMTCC1319',
          fullName: 'Hyderabad, Telangana'
        },
        {
          name: 'Kolhapur',
          code: 'MMTCC43090',
          fullName: 'Kolhapur, Maharashtra'
        },
        {
          name: 'Mahabaleshwar',
          code: 'MMTCC1528',
          fullName: 'Mahabaleshwar, Maharashtra'
        },
        {
          name: 'Indore',
          code: 'MMTCC1324',
          fullName: 'Indore, Madhya Pradesh'
        },
        {
          name: 'Mangalore',
          code: 'MMTCC1553',
          fullName: 'Mangalore, Karnataka'
        },
        {
          name: 'Ahmedabad',
          code: 'MMTCC1015',
          fullName: 'Ahmedabad, Gujarat'
        },
        {
          name: 'Aurangabad',
          code: 'MMTCC1070',
          fullName: 'Aurangabad, Maharashtra'
        },
        {
          name: 'Ratnagiri',
          code: 'MMTCC3859',
          fullName: 'Ratnagiri, Maharashtra'
        },
        {
          name: 'Nasik',
          code: 'MMTCC1640',
          fullName: 'Nasik, Maharashtra'
        },
        {
          name: 'Nagpur',
          code: 'MMTCC1619',
          fullName: 'Nagpur, Maharashtra'
        },
        {
          name: 'Belgaum',
          code: 'MMTCC1103',
          fullName: 'Belgaum, Karnataka'
        },
        {
          name: 'Delhi',
          code: 'MMTCC1199',
          fullName: 'Delhi'
        },
        {
          name: 'Surat',
          code: 'MMTCC1865',
          fullName: 'Surat, Gujarat'
        },
        {
          name: 'Lonavala',
          code: 'MMTCC1516',
          fullName: 'Lonavala, Maharashtra'
        },
        {
          name: 'Bhopal',
          code: 'MMTCC1119',
          fullName: 'Bhopal, Madhya Pradesh'
        }
      ]
    }
  ],
  MMTCC1744: [
    {
      title: 'popular cities',
      citieslist: [
        {
          name: 'Bangalore',
          code: 'MMTCC1092',
          fullName: 'Bangalore, Karnataka'
        },
        {
          name: 'Goa',
          code: 'MMTCC1271',
          fullName: 'Goa'
        },
        {
          name: 'Mumbai',
          code: 'MMTCC1599',
          fullName: 'Mumbai, Maharashtra'
        },
        {
          name: 'Nagpur',
          code: 'MMTCC1619',
          fullName: 'Nagpur, Maharashtra'
        },
        {
          name: 'Hyderabad',
          code: 'MMTCC1319',
          fullName: 'Hyderabad, Telangana'
        },
        {
          name: 'Shirdi',
          code: 'MMTCC1819',
          fullName: 'Shirdi, Maharashtra'
        },
        {
          name: 'Indore',
          code: 'MMTCC1324',
          fullName: 'Indore, Madhya Pradesh'
        },
        {
          name: 'Kolhapur',
          code: 'MMTCC43090',
          fullName: 'Kolhapur, Maharashtra'
        },
        {
          name: 'Ahmedabad',
          code: 'MMTCC1015',
          fullName: 'Ahmedabad, Gujarat'
        },
        {
          name: 'Bhopal',
          code: 'MMTCC1119',
          fullName: 'Bhopal, Madhya Pradesh'
        },
        {
          name: 'Nasik',
          code: 'MMTCC1640',
          fullName: 'Nasik, Maharashtra'
        },
        {
          name: 'Mahabaleshwar',
          code: 'MMTCC1528',
          fullName: 'Mahabaleshwar, Maharashtra'
        },
        {
          name: 'Latur',
          code: 'MMTCC1508',
          fullName: 'Latur, Maharashtra'
        },
        {
          name: 'Aurangabad',
          code: 'MMTCC1070',
          fullName: 'Aurangabad, Maharashtra'
        },
        {
          name: 'Nanded',
          code: 'MMTCC1628',
          fullName: 'Nanded, Maharashtra'
        },
        {
          name: 'Belgaum',
          code: 'MMTCC1103',
          fullName: 'Belgaum, Karnataka'
        },
        {
          name: 'Surat',
          code: 'MMTCC1865',
          fullName: 'Surat, Gujarat'
        },
        {
          name: 'Jalgaon',
          code: 'MMTCC1337',
          fullName: 'Jalgaon, Maharashtra'
        },
        {
          name: 'Amravati (MH)',
          code: 'MMTCC43169',
          fullName: 'Amravati, Maharashtra'
        },
        {
          name: 'Vadodara (Baroda)',
          code: 'MMTCC43363',
          fullName: 'Vadodara, Gujarat'
        }
      ]
    }
  ],
  MMTCC1159: [
    {
      title: 'popular cities',
      citieslist: [
        {
          name: 'Bangalore',
          code: 'MMTCC1092',
          fullName: 'Bangalore, Karnataka'
        },
        {
          name: 'Coimbatore',
          code: 'MMTCC1184',
          fullName: 'Coimbatore, Tamil Nadu'
        },
        {
          name: 'Madurai',
          code: 'MMTCC1526',
          fullName: 'Madurai, Tamil Nadu'
        },
        {
          name: 'Trichy',
          code: 'MMTCC1931',
          fullName: 'Trichy, Tamil Nadu'
        },
        {
          name: 'Pondicherry',
          code: 'MMTCC1732',
          fullName: 'Pondicherry'
        },
        {
          name: 'Hyderabad',
          code: 'MMTCC1319',
          fullName: 'Hyderabad, Telangana'
        },
        {
          name: 'Kodaikanal',
          code: 'MMTCC1449',
          fullName: 'Kodaikanal, Tamil Nadu'
        },
        {
          name: 'Ooty',
          code: 'MMTCC1661',
          fullName: 'Ooty, Tamil Nadu'
        },
        {
          name: 'Salem',
          code: 'MMTCC1791',
          fullName: 'Salem, Tamil Nadu'
        },
        {
          name: 'Nagercoil',
          code: 'MMTCC1616',
          fullName: 'Nagercoil, Tamil Nadu'
        },
        {
          name: 'Kumbakonam',
          code: 'MMTCC1488',
          fullName: 'Kumbakonam, Tamil Nadu'
        },
        {
          name: 'Tirupati',
          code: 'MMTCC1924',
          fullName: 'Tirupati, Andhra Pradesh'
        },
        {
          name: 'Velankanni',
          code: 'MMTCC1985',
          fullName: 'Velankanni, Tamil Nadu'
        },
        {
          name: 'Erode',
          code: 'MMTCC1249',
          fullName: 'Erode, Tamil Nadu'
        },
        {
          name: 'Munnar',
          code: 'MMTCC1604',
          fullName: 'Munnar, Kerala'
        },
        {
          name: 'Vellore',
          code: 'MMTCC1986',
          fullName: 'Vellore, Tamil Nadu'
        },
        {
          name: 'Trivandrum',
          code: 'MMTCC43372',
          fullName: 'Trivandrum, Kerala'
        },
        {
          name: 'Dindigul',
          code: 'MMTCC1223',
          fullName: 'Dindigul, Tamil Nadu'
        },
        {
          name: 'Ernakulam',
          code: 'MMTCC1248',
          fullName: 'Ernakulam, Kerala'
        },
        {
          name: 'Visakhapatnam (Vizag)',
          code: 'MMTCC43255',
          fullName: 'Visakhapatnam, Andhra Pradesh'
        }
      ]
    }
  ],
  MMTCC1319: [
    {
      title: 'popular cities',
      citieslist: [
        {
          name: 'Bangalore',
          code: 'MMTCC1092',
          fullName: 'Bangalore, Karnataka'
        },
        {
          name: 'Shirdi',
          code: 'MMTCC1819',
          fullName: 'Shirdi, Maharashtra'
        },
        {
          name: 'Mumbai',
          code: 'MMTCC1599',
          fullName: 'Mumbai, Maharashtra'
        },
        {
          name: 'Chennai',
          code: 'MMTCC1159',
          fullName: 'Chennai, Tamil Nadu'
        },
        {
          name: 'Goa',
          code: 'MMTCC1271',
          fullName: 'Goa'
        },
        {
          name: 'Visakhapatnam (Vizag)',
          code: 'MMTCC43255',
          fullName: 'Visakhapatnam, Andhra Pradesh'
        },
        {
          name: 'Tirupati',
          code: 'MMTCC1924',
          fullName: 'Tirupati, Andhra Pradesh'
        },
        {
          name: 'Pune',
          code: 'MMTCC1744',
          fullName: 'Pune, Maharashtra'
        },
        {
          name: 'Vijayawada',
          code: 'MMTCC1995',
          fullName: 'Vijayawada, Andhra Pradesh'
        },
        {
          name: 'Nagpur',
          code: 'MMTCC1619',
          fullName: 'Nagpur, Maharashtra'
        },
        {
          name: 'Coimbatore',
          code: 'MMTCC1184',
          fullName: 'Coimbatore, Tamil Nadu'
        },
        {
          name: 'Rajahmundry',
          code: 'MMTCC5916',
          fullName: 'Rajahmundry, Andhra Pradesh'
        },
        {
          name: 'Mysore',
          code: 'MMTCC1611',
          fullName: 'Mysore, Karnataka'
        },
        {
          name: 'Guntur',
          code: 'MMTCC1288',
          fullName: 'Guntur, Andhra Pradesh'
        },
        {
          name: 'Nellore',
          code: 'MMTCC1644',
          fullName: 'Nellore, Andhra Pradesh'
        },
        {
          name: 'Pondicherry',
          code: 'MMTCC1732',
          fullName: 'Pondicherry'
        },
        {
          name: 'Kakinada',
          code: 'MMTCC1363',
          fullName: 'Kakinada, Andhra Pradesh'
        },
        {
          name: 'Ramoji Film City',
          code: 'MMTCC9999',
          fullName: 'Ramoji Film City, Andhra Pradesh'
        },
        {
          name: 'Madurai',
          code: 'MMTCC1526',
          fullName: 'Madurai, Tamil Nadu'
        },
        {
          name: 'Mangalore',
          code: 'MMTCC1553',
          fullName: 'Mangalore, Karnataka'
        }
      ]
    }
  ],
  MMTCC1149: [
    {
      title: 'popular cities',
      citieslist: [
        {
          name: 'Manali',
          code: 'MMTCC1543',
          fullName: 'Manali, Himachal Pradesh'
        },
        {
          name: 'Shimla',
          code: 'MMTCC1815',
          fullName: 'Shimla, Himachal Pradesh'
        },
        {
          name: 'Delhi',
          code: 'MMTCC1199',
          fullName: 'Delhi'
        },
        {
          name: 'Amritsar',
          code: 'MMTCC1043',
          fullName: 'Amritsar, Punjab'
        },
        {
          name: 'Dharamshala',
          code: 'MMTCC6060',
          fullName: 'Dharamshala, Himachal Pradesh'
        },
        {
          name: 'Jammu',
          code: 'MMTCC47573',
          fullName: 'Jammu, Jammu and Kashmir'
        },
        {
          name: 'Katra',
          code: 'MMTCC43152',
          fullName: 'Katra, Jammu and Kashmir'
        },
        {
          name: 'Haridwar',
          code: 'MMTCC1295',
          fullName: 'Haridwar, Uttarakhand'
        },
        {
          name: 'Kullu',
          code: 'MMTCC1487',
          fullName: 'Kullu, Himachal Pradesh'
        },
        {
          name: 'Pathankot',
          code: 'MMTCC3712',
          fullName: 'Pathankot, Punjab'
        },
        {
          name: 'Jalandhar',
          code: 'MMTCC1336',
          fullName: 'Jalandhar, Punjab'
        },
        {
          name: 'Ludhiana',
          code: 'MMTCC1517',
          fullName: 'Ludhiana, Punjab'
        },
        {
          name: 'Jaipur',
          code: 'MMTCC1333',
          fullName: 'Jaipur, Rajasthan'
        },
        {
          name: 'Bathinda',
          code: 'MMTCC6089',
          fullName: 'Bathinda, Punjab'
        },
        {
          name: 'Mandi',
          code: 'MMTCC14043',
          fullName: 'Mandi, Punjab'
        },
        {
          name: 'Bhuntar',
          code: 'MMTCC10565',
          fullName: 'Bhuntar, Himachal Pradesh'
        },
        {
          name: 'Hamirpur',
          code: 'MMTCC6061',
          fullName: 'Hamirpur,Himachal Pradesh'
        },
        {
          name: 'Mcleod Ganj',
          code: 'MMTCC10671',
          fullName: 'Mcleod Ganj, Himachal Pradesh'
        },
        {
          name: 'Kangra',
          code: 'MMTCC3682',
          fullName: 'Kangra, Himachal Pradesh'
        },
        {
          name: 'Hoshiarpur',
          code: 'MMTCC6094',
          fullName: 'Hoshiarpur, Punjab'
        }
      ]
    }
  ],
  MMTCC6117: [
    {
      title: 'popular cities',
      citieslist: [
        {
          name: 'Siliguri',
          code: 'MMTCC5560',
          fullName: 'Siliguri, West Bengal'
        },
        {
          name: 'Digha',
          code: 'MMTCC5569',
          fullName: 'Digha, West Bengal'
        },
        {
          name: 'Puri',
          code: 'MMTCC5586',
          fullName: 'Puri, Odisha'
        },
        {
          name: 'Bhubaneswar',
          code: 'MMTCC5474',
          fullName: 'Bhubaneswar, Odisha'
        },
        {
          name: 'Durgapur',
          code: 'MMTCC5568',
          fullName: 'Durgapur, West Bengal'
        },
        {
          name: 'Patna',
          code: 'MMTCC6045',
          fullName: 'Patna, Bihar'
        },
        {
          name: 'Asansol',
          code: 'MMTCC5575',
          fullName: 'Asansol, West Bengal'
        },
        {
          name: 'Malda',
          code: 'MMTCC5578',
          fullName: 'Malda, West Bengal'
        },
        {
          name: 'Ranchi',
          code: 'MMTCC6064',
          fullName: 'Ranchi, Jharkhand'
        },
        {
          name: 'Mandarmani',
          code: 'MMTCC37974',
          fullName: 'Mandarmani, West Bengal'
        },
        {
          name: 'Cuttack',
          code: 'MMTCC5502',
          fullName: 'Cuttack, Odisha'
        },
        {
          name: 'Bokaro',
          code: 'MMTCC5579',
          fullName: 'Bokaro, Jharkhand'
        },
        {
          name: 'Dhanbad',
          code: 'MMTCC5580',
          fullName: 'Dhanbad, Jharkhand'
        },
        {
          name: 'Haldia',
          code: 'MMTCC5577',
          fullName: 'Haldia, West Bengal'
        }
      ]
    }
  ],
  MMTCC1333: [
    {
      title: 'popular cities',
      citieslist: [
        {
          name: 'Delhi',
          code: 'MMTCC1199',
          fullName: 'Delhi'
        },
        {
          name: 'Ahmedabad',
          code: 'MMTCC1015',
          fullName: 'Ahmedabad, Gujarat'
        },
        {
          name: 'Udaipur (Rajasthan)',
          code: 'MMTCC38804',
          fullName: 'Udaipur, Rajasthan'
        },
        {
          name: 'Agra',
          code: 'MMTCC3641',
          fullName: 'Agra, Uttar Pradesh'
        },
        {
          name: 'Lucknow',
          code: 'MMTCC2161',
          fullName: 'Lucknow, Uttar Pradesh'
        },
        {
          name: 'Jodhpur',
          code: 'MMTCC1349',
          fullName: 'Jodhpur, Rajasthan'
        },
        {
          name: 'Haridwar',
          code: 'MMTCC1295',
          fullName: 'Haridwar, Uttarakhand'
        },
        {
          name: 'Gurgaon',
          code: 'MMTCC5409',
          fullName: 'Gurgaon, Haryana'
        },
        {
          name: 'Bikaner',
          code: 'MMTCC1126',
          fullName: 'Bikaner, Rajasthan'
        },
        {
          name: 'Ajmer',
          code: 'MMTCC1019',
          fullName: 'Ajmer, Rajasthan'
        },
        {
          name: 'Chandigarh',
          code: 'MMTCC1149',
          fullName: 'Chandigarh'
        },
        {
          name: 'Mumbai',
          code: 'MMTCC1599',
          fullName: 'Mumbai, Maharashtra'
        },
        {
          name: 'Kanpur',
          code: 'MMTCC2140',
          fullName: 'Kanpur, Uttar Pradesh'
        },
        {
          name: 'Indore',
          code: 'MMTCC1324',
          fullName: 'Indore, Madhya Pradesh'
        },
        {
          name: 'Kota Rajasthan',
          code: 'MMTCC43246',
          fullName: 'Kota, Rajasthan'
        },
        {
          name: 'Dehradun',
          code: 'MMTCC1198',
          fullName: 'Dehradun, Uttarakhand'
        },
        {
          name: 'Surat',
          code: 'MMTCC1865',
          fullName: 'Surat, Gujarat'
        },
        {
          name: 'Gwalior',
          code: 'MMTCC5366',
          fullName: 'Gwalior, Madhya Pradesh'
        },
        {
          name: 'Mount Abu',
          code: 'MMTCC12671',
          fullName: 'Mount Abu, Rajasthan'
        },
        {
          name: 'Pune',
          code: 'MMTCC1744',
          fullName: 'Pune, Maharashtra'
        }
      ]
    }
  ],
  MMTCC2161: [
    {
      title: 'popular cities',
      citieslist: [
        {
          name: 'Delhi',
          code: 'MMTCC1199',
          fullName: 'Delhi'
        },
        {
          name: 'Gorakhpur',
          code: 'MMTCC5780',
          fullName: 'Gorakhpur, Uttar Pradesh'
        },
        {
          name: 'Varanasi',
          code: 'MMTCC5425',
          fullName: ' Varanasi, Uttar Pradesh'
        },
        {
          name: 'Allahabad',
          code: 'MMTCC5713',
          fullName: 'Allahabad, Uttar Pradesh'
        },
        {
          name: 'Dehradun',
          code: 'MMTCC1198',
          fullName: 'Dehradun, Uttarakhand'
        },
        {
          name: 'Haridwar',
          code: 'MMTCC1295',
          fullName: 'Haridwar, Uttarakhand'
        },
        {
          name: 'Agra',
          code: 'MMTCC3641',
          fullName: 'Agra, Uttar Pradesh'
        },
        {
          name: 'Jaipur',
          code: 'MMTCC1333',
          fullName: 'Jaipur, Rajasthan'
        },
        {
          name: 'Kanpur',
          code: 'MMTCC2140',
          fullName: 'Kanpur, Uttar Pradesh'
        },
        {
          name: 'Azamgarh',
          code: 'MMTCC6107',
          fullName: 'Azamgarh, Uttar Pradesh'
        },
        {
          name: 'Jhansi',
          code: 'MMTCC2130',
          fullName: 'Jhansi, Uttar Pradesh'
        },
        {
          name: 'Bareilly',
          code: 'MMTCC2081',
          fullName: 'Bareilly, Uttar Pradesh'
        },
        {
          name: 'Ghaziabad',
          code: 'MMTCC43265',
          fullName: 'Ghaziabad, Uttar Pradesh'
        },
        {
          name: 'Noida',
          code: 'MMTCC2195',
          fullName: 'Noida, Uttar Pradesh'
        },
        {
          name: 'Moradabad',
          code: 'MMTCC2182',
          fullName: 'Moradabad, Uttar Pradesh'
        },
        {
          name: 'Mau',
          code: 'MMTCC6869',
          fullName: 'Mau, Uttar Pradesh'
        }
      ]
    }
  ],
  MMTCC1184: [
    {
      title: 'popular cities',
      citieslist: [
        {
          name: 'Chennai',
          code: 'MMTCC1159',
          fullName: 'Chennai, Tamil Nadu'
        },
        {
          name: 'Bangalore',
          code: 'MMTCC1092',
          fullName: 'Bangalore, Karnataka'
        },
        {
          name: 'Hyderabad',
          code: 'MMTCC1319',
          fullName: 'Hyderabad, Telangana'
        },
        {
          name: 'Madurai',
          code: 'MMTCC1526',
          fullName: 'Madurai, Tamil Nadu'
        },
        {
          name: 'Tirupati',
          code: 'MMTCC1924',
          fullName: 'Tirupati, Andhra Pradesh'
        },
        {
          name: 'Pondicherry',
          code: 'MMTCC1732',
          fullName: 'Pondicherry'
        },
        {
          name: 'Trichy',
          code: 'MMTCC1931',
          fullName: 'Trichy, Tamil Nadu'
        },
        {
          name: 'Ernakulam',
          code: 'MMTCC1248',
          fullName: 'Ernakulam, Kerala'
        },
        {
          name: 'Cochin',
          code: 'MMTCC37575',
          fullName: 'Cochin, Kerala'
        },
        {
          name: 'Nagercoil',
          code: 'MMTCC1616',
          fullName: 'Nagercoil, Tamil Nadu'
        },
        {
          name: 'Trivandrum',
          code: 'MMTCC43372',
          fullName: 'Trivandrum, Kerala'
        },
        {
          name: 'Tiruchendur',
          code: 'MMTCC1917',
          fullName: 'Tiruchendur, Tamil Nadu'
        }
      ]
    }
  ],
  MMTCC1271: [
    {
      title: 'popular cities',
      citieslist: [
        {
          name: 'Mumbai',
          code: 'MMTCC1599',
          fullName: 'Mumbai, Maharashtra'
        },
        {
          name: 'Pune',
          code: 'MMTCC1744',
          fullName: 'Pune, Maharashtra'
        },
        {
          name: 'Bangalore',
          code: 'MMTCC1092',
          fullName: 'Bangalore, Karnataka'
        },
        {
          name: 'Hyderabad',
          code: 'MMTCC1319',
          fullName: 'Hyderabad, Telangana'
        },
        {
          name: 'Kolhapur',
          code: 'MMTCC43090',
          fullName: 'Kolhapur, Maharashtra'
        },
        {
          name: 'Shirdi',
          code: 'MMTCC1819',
          fullName: 'Shirdi, Maharashtra'
        },
        {
          name: 'Mangalore',
          code: 'MMTCC1553',
          fullName: 'Mangalore, Karnataka'
        },
        {
          name: 'Chennai',
          code: 'MMTCC1159',
          fullName: 'Chennai, Tamil Nadu'
        }
      ]
    }
  ],
  MMTCC1543: [
    {
      title: 'popular cities',
      citieslist: [
        {
          name: 'Delhi',
          code: 'MMTCC1199',
          fullName: 'Delhi'
        },
        {
          name: 'Chandigarh',
          code: 'MMTCC1149',
          fullName: 'Chandigarh'
        },
        {
          name: 'Shimla',
          code: 'MMTCC1815',
          fullName: 'Shimla, Himachal Pradesh'
        },
        {
          name: 'Ambala',
          code: 'MMTCC2069',
          fullName: 'Ambala, Haryana'
        },
        {
          name: 'Dharamshala',
          code: 'MMTCC6060',
          fullName: 'Dharamshala, Himachal Pradesh'
        }
      ]
    }
  ],
  MMTCC1815: [
    {
      title: 'popular cities',
      citieslist: [
        {
          name: 'Delhi',
          code: 'MMTCC1199',
          fullName: 'Delhi'
        },
        {
          name: 'Manali',
          code: 'MMTCC1543',
          fullName: 'Manali, Himachal Pradesh'
        },
        {
          name: 'Chandigarh',
          code: 'MMTCC1149',
          fullName: 'Chandigarh'
        }
      ]
    }
  ],
  MMTCC1295: [
    {
      title: 'popular cities',
      citieslist: [
        {
          name: 'Delhi',
          code: 'MMTCC1199',
          fullName: 'Delhi'
        },
        {
          name: 'Lucknow',
          code: 'MMTCC2161',
          fullName: 'Lucknow, Uttar Pradesh'
        },
        {
          name: 'Jaipur',
          code: 'MMTCC1333',
          fullName: 'Jaipur, Rajasthan'
        }
      ]
    }
  ]
};
